import type { ToasterProps } from "sonner";

import { Toaster } from "../primitives/sonner";

/**
 * Mount `<TenkoToaster />` once in the app root to enable toast notifications. Do not mount it more than
 * once.
 *
 * To fire toasts from anywhere in the app, use `tenkoToast` from `@/shared/utils/toast` — never import
 * `toast` from `"sonner"` directly.
 *
 * @summary single mount point for all toast notifications — place in app root only
 */
export function TenkoToaster(props: ToasterProps) {
  return <Toaster position="top-right" richColors={true} {...props} />;
}
